import type { EnvironmentConfig } from './environment-config';

export const environment: EnvironmentConfig = {
  production: false,
  rootDomain: 'sportdesk.ro',
  apiBaseUrl: 'https://dev-api.sportdesk.ro',
  facturApiBaseUrl: 'https://dev-api.factur.ro',
  facturAppBaseUrl: 'https://dev.factur.ro',
  termsVersion: '2026-04',
  privacyVersion: '2026-04',
  buildVersion: '1.0.2',
  buildCommit: 'e6637291',
  buildDate: '2026-06-10',
  subdomainPrefix: 'dev-',
  extraPlatformHosts: ['dev.sportdesk.ro'],
};
